import SelectComponent from "formiojs/components/select/Select";
import Formio from "formiojs/Formio";
import { environment } from "../../../environments/environment";

export class SelectWithAddComponent extends SelectComponent {

  private choices: any;
  private currentItems: [];
  private options: any;
  private requestHeaders: any;
  private loadItems: any;
  private baseUrl: string = environment.BASE_URL;

  static get builderInfo() {
    return {
      title: "catalogue",
      group: "basic2", // different group name to remove from toolbar
      icon: "fas fa-server",
      weight: 70,
      documentation: "http://help.form.io/userguide/#select",
      schema: SelectComponent.schema(),
    };
  }

  public addInput(input: any, container: any) {
    super.addInput(input, container);
    if (this.choices && this.choices.passedElement && this.choices.passedElement.element) {
      this.choices.passedElement.element.addEventListener("addItem", (event) => {
        if (this.choices.input && this.choices.input.element) {
          this.choices.input.element.value = "";
          this.choices.input.element.dispatchEvent(new Event("input", { bubbles: true }));
        }
      });
    }
    if (this.choices && this.choices.input && this.choices.input.element) {
      this.choices.input.element.addEventListener("keyup", (ev: any) => {
        let addbutton = document.querySelector("#tagaddbutton");
        if (this.currentItems && this.currentItems.some((item: any) => item.name === ev.target.value)) {
          if (addbutton && addbutton.parentNode) { addbutton.parentNode.removeChild(addbutton); }
          return;
        }
        if (ev.target.value.length < 4) {
          if (addbutton && addbutton.parentNode) { addbutton.parentNode.removeChild(addbutton); }
          return;
        }
        if (!addbutton) {
          addbutton = document.createElement("button", {});
          addbutton.setAttribute("id", "tagaddbutton");
          addbutton.classList.add("btn");
          const btnText = document.createTextNode("Add tag");
          addbutton.appendChild(btnText);
          this.choices.input.element.parentNode.appendChild(addbutton);

          addbutton.addEventListener("click", () => {
            this.requestHeaders.then((headers) => {
              Formio.makeRequest(this.options.formio, "select", this.baseUrl + "tag", "POST", ev.target.value, { header: headers }).then(() => {
                this.loadItems(this.baseUrl + "tag", ev.target.value, headers, { ignoreCache: true }, "GET");
                ev.target.value = "";
                if (addbutton.parentNode) {
                  addbutton.parentNode.removeChild(addbutton);
                }
              });
            });
          });
        }
      });
    }
  }
}
